import * as React from 'react';

export default function ArrowRightAlt({...rest}) {
  return (
    <svg
      {...rest}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9915 5.87891L15.1048 6.86891C17.2094 8.75411 18.9171 10.4696 19.8867 11.5037H1.99219V12.8337H19.8694C18.9006 13.8508 17.2074 15.5327 15.105 17.4167L15.9917 18.4067C16.0523 18.353 21.9917 13.0209 21.9917 12.1684C21.9915 11.2919 16.0523 5.93261 15.9915 5.87891Z"
        fill="white"
      />
    </svg>
  );
}
